import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

const ApprentiPrep = () => {
  return (
    <div className="min-h-screen bg-white text-[#333333]">
      <Helmet>
        <title>ApprentiPrep | Infinity Cloud</title>
        <meta name="description" content="ApprentiPrep - Application iPhone révolutionnaire avec suivi IA en temps réel des examens et itération automatique" />
      </Helmet>

      {/* Hero Section */}
      <section className="pt-2 pb-0.5 overflow-hidden relative" style={{ backgroundColor: 'white', background: 'white' }}>
        <div className="container mx-auto px-4 relative z-10" style={{ backgroundColor: 'white' }}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
            style={{ backgroundColor: 'white' }}
          >
            <h1 className="text-5xl md:text-6xl font-bold mb-1">
              <span 
                style={{
                  background: 'linear-gradient(135deg, #0066cc, #5ac8fa)',
                  WebkitBackgroundClip: 'text',
                  backgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  paddingBottom: '0.1em',
                  lineHeight: 1.1
                }}
              >
                ApprentiPrep
              </span>
            </h1>
            <div 
              style={{ 
                padding: '5px',
                marginBottom: '10px',
                position: 'relative',
                zIndex: 50,
              }}
            >
              <p 
                className="text-xl text-[#666666] max-w-3xl mx-auto" 
              >
                L'application iPhone révolutionnaire qui transforme la préparation aux examens grâce à l'IA temps réel et l'analyse avancée de vos performances
              </p>
            </div>
            
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.3, duration: 0.6 }}
              className="mt-1 flex justify-center gap-4 flex-wrap md:flex-nowrap"
            >
              <div className="relative shadow-2xl" style={{ maxWidth: '280px', borderRadius: '40px', overflow: 'hidden' }}>
                <img 
                  src="/images/real_app/IMG_1778.PNG" 
                  alt="ApprentiPrep Dashboard" 
                  className="w-full h-auto rounded-[40px]"
                  style={{ animation: 'float 6s ease-in-out infinite' }}
                />
              </div>
              <div className="relative shadow-2xl" style={{ maxWidth: '280px', borderRadius: '40px', overflow: 'hidden' }}>
                <img 
                  src="/images/real_app/IMG_1779.PNG" 
                  alt="ApprentiPrep Analytics" 
                  className="w-full h-auto rounded-[40px]"
                  style={{ animation: 'float 6s ease-in-out infinite 0.5s' }}
                />
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Fonctionnalités */}
      <section className="py-0.5 bg-white">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="mb-0.5"
          >
            <h2 className="text-4xl font-semibold mb-0.5 text-[#333333] text-left">
              <span 
                style={{
                  background: 'linear-gradient(135deg, #0066cc, #5ac8fa)',
                  WebkitBackgroundClip: 'text',
                  backgroundClip: 'text',
                  WebkitTextFillColor: 'transparent'
                }}
              >
                Suivi Intelligent d'Examens
              </span>
            </h2>
            <p className="text-lg text-[#666666] mb-1">
              ApprentiPrep propose une suite complète d'outils innovants pour maximiser votre préparation et votre performance aux examens.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mt-1">
              <div className="text-left">
                <h3 className="text-xl font-semibold mb-0.5 text-[#0066cc]">Analyse en Temps Réel</h3>
                <p className="text-[#666666] mb-1">
                  Bénéficiez d'un suivi instantané de vos performances avec des métriques détaillées et des indicateurs de progression qui vous permettent de visualiser clairement vos avancées. Le système analyse vos résultats et identifie automatiquement vos points forts et vos axes d'amélioration.
                </p>
                
                <h3 className="text-xl font-semibold mb-0.5 text-[#0066cc]">Itération Automatique</h3>
                <p className="text-[#666666]">
                  Notre algorithme d'IA génère intelligemment des exercices personnalisés ciblant précisément vos points faibles identifiés. Chaque session d'étude devient ainsi plus efficace, en se concentrant sur les domaines qui nécessitent vraiment votre attention.
                </p>
              </div>
              
              <div className="text-left">
                <h3 className="text-xl font-semibold mb-0.5 text-[#0066cc]">Préparation Optimisée</h3>
                <p className="text-[#666666] mb-1">
                  Profitez d'une planification intelligente de vos sessions d'étude, conçue pour maximiser la rétention et l'efficacité. Le système utilise les principes de la science cognitive pour programmer vos révisions aux moments optimaux pour la mémorisation à long terme.
                </p>
                
                <h3 className="text-xl font-semibold mb-0.5 text-[#0066cc]">Coach IA Intégré</h3>
                <p className="text-[#666666]">
                  Un assistant pédagogique alimenté par l'IA qui répond à vos questions, vous guide dans votre apprentissage et vous motive tout au long de votre parcours. Disponible 24/7, il s'adapte à votre style d'apprentissage et à vos besoins spécifiques.
                </p>
              </div>
            </div>
            
            {/* Image DALL-E au format panoramique pour mieux s'intégrer */}
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="mt-1 w-full overflow-hidden rounded-xl shadow-lg"
              style={{ animation: 'float 8s ease-in-out infinite' }}
            >
              <div className="relative w-full" style={{ height: '220px', overflow: 'hidden' }}>
                <img 
                  src="/images/generated/apprentiprep-dashboard-wide.png" 
                  alt="Interface d'analyse des performances ApprentiPrep" 
                  className="w-full h-full object-cover"
                />
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Interface */}
      <section className="pb-0.5 bg-white">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row gap-2 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="flex-1 order-2 md:order-1"
            >
              <span 
                style={{
                  background: 'linear-gradient(135deg, #0066cc, #5ac8fa)',
                  WebkitBackgroundClip: 'text',
                  backgroundClip: 'text',
                  WebkitTextFillColor: 'transparent'
                }}
                className="text-xl font-medium inline-block mb-0.5"
              >
                Interface Utilisateur
              </span>
              <h2 className="text-3xl font-semibold mb-1">Design Minimaliste et Efficace</h2>
              <p className="text-[#666666] mb-1">
                Une interface intuitive conçue selon les principes de design Apple, permettant une navigation fluide et une concentration maximale sur l'apprentissage.
              </p>
              
              <ul className="space-y-0.5">
                {[
                  "Visualisations claires des données de performance",
                  "Système de notation par couleur pour une compréhension immédiate",
                  "Navigation gestuelle optimisée pour une utilisation à une main",
                  "Mode sombre et mode clair automatiquement synchronisés avec vos préférences système"
                ].map((item, index) => (
                  <motion.li 
                    key={index}
                    initial={{ opacity: 0, x: 20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.3, delay: 0.1 * index }}
                    className="flex items-start"
                  >
                    <svg className="w-4 h-4 mt-1 text-[#0066cc] mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-[#666666]">{item}</span>
                  </motion.li>
                ))}
              </ul>
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="flex-1 order-1 md:order-2 flex justify-center"
              style={{ animation: 'float 7s ease-in-out infinite 0.7s' }}
            >
              <img 
                src="/images/real_app/IMG_1780.PNG" 
                alt="ApprentiPrep Interface" 
                className="max-w-full rounded-[40px] shadow-2xl"
                style={{ maxHeight: '500px' }}
              />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Technologie */}
      <section className="py-0.5 bg-white">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-1"
          >
            <span 
              style={{
                background: 'linear-gradient(135deg, #0066cc, #5ac8fa)',
                WebkitBackgroundClip: 'text',
                backgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}
              className="text-xl font-medium inline-block mb-0.5"
            >
              Technologie
            </span>
            <h2 className="text-4xl font-semibold mb-1 text-[#333333]">
              Intelligence Artificielle Intégrée
            </h2>
            <p className="max-w-2xl mx-auto text-lg text-[#666666]">
              ApprentiPrep exploite la puissance des modèles IA de pointe pour offrir une expérience d'apprentissage personnalisée
            </p>
          </motion.div>

          <div className="flex flex-col md:flex-row gap-2 items-center mt-1">
            <div className="md:w-1/2" style={{ animation: 'float 7s ease-in-out infinite 1.2s' }}>
              <img 
                src="/images/real_app/IMG_1782.PNG" 
                alt="ApprentiPrep AI Coach" 
                className="rounded-[40px] shadow-2xl mx-auto"
                style={{ maxHeight: '500px' }}
              />
            </div>
            
            <div className="md:w-1/2">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
                className="mb-1"
              >
                <h3 className="text-xl font-semibold mb-0.5 text-[#0066cc]">Modèles IA Avancés</h3>
                <p className="text-[#666666]">
                  Choisissez parmi différents modèles d'IA (local, OpenAI ou Google Gemini) pour alimenter votre coach personnel et obtenir les performances qui correspondent à vos besoins.
                </p>
              </motion.div>
              
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="mb-1"
              >
                <h3 className="text-xl font-semibold mb-0.5 text-[#0066cc]">Confidentialité Maximale</h3>
                <p className="text-[#666666]">
                  Avec notre option de modèle local, vos données restent sur votre appareil, garantissant une confidentialité totale sans compromettre la qualité de l'assistance.
                </p>
              </motion.div>
              
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <h3 className="text-xl font-semibold mb-0.5 text-[#0066cc]">Système Adaptif</h3>
                <p className="text-[#666666]">
                  L'IA s'adapte continuellement à vos progrès, ajustant la difficulté des exercices et les stratégies d'apprentissage pour maximiser votre progression.
                </p>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* Prochaine Génération */}
      <section className="pt-0.5 bg-white">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-1"
          >
            <span 
              style={{
                background: 'linear-gradient(135deg, #0066cc, #5ac8fa)',
                WebkitBackgroundClip: 'text',
                backgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}
              className="text-xl font-medium inline-block mb-0.5"
            >
              En Développement
            </span>
            <h2 className="text-4xl font-semibold mb-1 text-[#333333]">
              Suite du Genius Framework
            </h2>
            <p className="max-w-2xl mx-auto text-lg text-[#666666]">
              ApprentiPrep représente la deuxième itération de notre plateforme éducative, avec des fonctionnalités avancées en cours de développement
            </p>
          </motion.div>

          <div className="flex flex-col md:flex-row gap-2 items-center mt-1">
            <div className="md:w-1/2" style={{ animation: 'float 6s ease-in-out infinite 0.3s' }}>
              <img 
                src="/images/real_app/IMG_1781.PNG" 
                alt="ApprentiPrep EVA Tests" 
                className="rounded-[40px] shadow-2xl mx-auto"
                style={{ maxHeight: '500px' }}
              />
            </div>
            
            <div className="md:w-1/2">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
                className="mb-1"
              >
                <h3 className="text-xl font-semibold mb-0.5 text-[#0066cc]">Reconnaissance OCR</h3>
                <p className="text-[#666666]">
                  Analyse des notes manuscrites et conversion automatique en format numérique pour une intégration parfaite dans votre processus d'apprentissage.
                </p>
              </motion.div>
              
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="mb-1"
              >
                <h3 className="text-xl font-semibold mb-0.5 text-[#0066cc]">Apprentissage Collaboratif</h3>
                <p className="text-[#666666]">
                  Mise en relation avec d'autres étudiants ayant des profils d'apprentissage complémentaires pour enrichir votre expérience d'étude.
                </p>
              </motion.div>
              
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <h3 className="text-xl font-semibold mb-0.5 text-[#0066cc]">Vision ML</h3>
                <p className="text-[#666666]">
                  Reconnaissance et analyse d'équations et de schémas scientifiques par l'appareil photo pour une compréhension visuelle approfondie.
                </p>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* Call To Action */}
      <section className="pb-1 bg-gradient-to-r from-[#0066cc] to-[#5ac8fa] text-white">
        <div className="container mx-auto px-4 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-4xl font-bold mb-1">Restez informé du lancement</h2>
            <p className="max-w-2xl mx-auto text-lg mb-1 text-white/90">
              ApprentiPrep est actuellement en phase de test auprès d'étudiants sélectionnés. Inscrivez-vous pour être parmi les premiers à l'essayer.
            </p>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="px-8 py-3 bg-white text-[#0066cc] font-semibold rounded-full shadow-lg hover:shadow-xl transition-all"
              onClick={() => window.location.href='/contact'}
            >
              Rejoindre la liste d'attente
            </motion.button>
            <div className="mt-1 text-sm text-white/70">
              En utilisant ApprentiPrep, vous acceptez nos{' '}
              <Link to="/apprentiprep/terms" className="text-white underline hover:text-white/90">
                Conditions d'utilisation
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      <style>
        {`
          @keyframes float {
            0% { transform: translateY(0px) rotate(0deg); }
            50% { transform: translateY(-10px) rotate(1deg); }
            100% { transform: translateY(0px) rotate(0deg); }
          }
        `}
      </style>
    </div>
  );
};

export default ApprentiPrep; 